import { createQueryKeys } from '@/lib/query-factory';
import { queryOptions } from '@tanstack/react-query';
import * as api from './my-hours.api';
import { getWeekBounds } from './my-hours.utils';

const keys = createQueryKeys('my-hours');

export const myHoursQueries = {
  keys,

  /**
   * Query labor entries for a specific user and week
   */
  week: (userId: number, weekString: string) => {
    const { start, end } = getWeekBounds(weekString);
    return queryOptions({
      queryKey: [...keys.list(), userId, weekString],
      queryFn: () => api.fetchMyWeekLabor(userId, start, end),
      enabled: !!userId && !!weekString,
    });
  },
};
